export const MovieShowTime = [
  {
    id: 221,
    movie_detail: {
      title: 'Surongo (2D)',
      length: '148 Min',
      img: 'https://image.cineplexbd.com/movies/168785990942815.webp',
      video: 'https://www.youtube.com/watch?v=p4ZaJCKxTJM',
      rating: '0.0',
      category: '2D',
      actor: 'Afran Nisho, Tama Mirza',
      genre: 'Drama,Thriller',
      release: '29-06-2023',
      language: 'Bangla',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '10:50 AM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
          {
            time: '04:30 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '10:50 AM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
          {
            time: '04:30 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '22nd , August 2023',
        date_name: 'Tuesday ',
        slot: [
          {
            time: '10:50 AM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
          {
            time: '04:30 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '10:50 AM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
          {
            time: '04:30 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '25st , August 2023',
        date_name: 'Friday ',
        slot: [
          {
            time: '10:50 AM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
          {
            time: '04:30 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
    ],
  },
  {
    id: 212,
    movie_detail: {
      title: 'Teenage Mutant Ninja Turtles: Mutant Mayhem',
      length: '99 Min',
      img: 'https://image.cineplexbd.com/movies/168594378125170.webp',
      video: 'https://www.youtube.com/watch?v=IHvzw4Ibuho',
      rating: '0.0',
      category: '3D',
      actor: 'Rose Byrne, Paul Rudd, Seth Rogen',
      genre: 'Action,Adventure,Animation',
      release: '11-08-2023',
      language: 'English',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },

      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
    ],
  },
  {
    id: 193,
    movie_detail: {
      title: 'Barbie',
      length: '1h 48m',
      img: 'https://image.cineplexbd.com/movies/167854534392362.webp',
      video: null,
      rating: '0.0',
      category: '2D',
      actor: 'Margot Robbie',
      genre: 'Family',
      release: '21-07-2023',
      language: 'English',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '11:30 AM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '01:55 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:45 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '11:30 AM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '01:55 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:45 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
        ],
      },
      {
        date: '22nd , August 2023',
        date_name: 'Tuesday ',
        slot: [
          {
            time: '11:30 AM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '01:55 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:45 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
        ],
      },
      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '11:30 AM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '01:55 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:45 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
        ],
      },
    ],
  },
  {
    id: 220,
    movie_detail: {
      title: 'Priyotoma (2D)',
      length: '140 Min',
      img: 'https://image.cineplexbd.com/movies/168786602980721.webp',
      video: 'https://www.youtube.com/watch?v=t1tQCeqacyg',
      rating: '0.0',
      category: '2D',
      actor: 'Sakib Khan, Idhika Paul',
      genre: 'Action,Drama',
      release: '29-06-2023',
      language: 'Bangla',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '22nd , August 2023',
        date_name: 'Tuesday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '01:35 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
    ],
  },
  {
    id: 213,
    movie_detail: {
      title: 'Meg 2: The Trench',
      length: '90 Min',
      img: 'https://image.cineplexbd.com/movies/168594381739062.webp',
      video: 'https://www.youtube.com/watch?v=dG91B3hHyY4',
      rating: '0.0',
      category: '3D',
      actor: 'Jason Statham, Jing Wu',
      genre: 'Action,Horror,Adventure',
      release: '11-08-2023',
      language: 'English',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '11:00 AM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '04:40 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '11:00 AM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '04:40 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '22nd , August 2023',
        date_name: 'Tuesday ',
        slot: [
          {
            time: '11:00 AM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '04:40 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '11:00 AM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '04:40 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
    ],
  },
  {
    id: 224,
    movie_detail: {
      title: 'Oppenheimer',
      length: '180 min',
      img: 'https://image.cineplexbd.com/movies/168889707325311.webp',
      video: 'https://www.youtube.com/watch?v=uYPbbksJxIg',
      rating: '0.0',
      category: '2D',
      actor: 'Cillian Murphy, Emily Blunt',
      genre: 'Biography',
      release: '21-07-2023',
      language: 'English',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '04:15 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:00 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '04:15 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:00 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '22nd , August 2023',
        date_name: 'Tuesday ',
        slot: [
          {
            time: '04:15 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:00 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '04:15 PM',
            hall: 2,
            hall_id: 8,
            hall_type: 'Premium',
          },
          {
            time: '07:00 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
        ],
      },
    ],
  },
  {
    id: 192,
    movie_detail: {
      title: 'Mission: Impossible - Dead Reckoning Part One',
      length: '2h 00m',
      img: 'https://image.cineplexbd.com/movies/167854525576631.webp',
      video: null,
      rating: '0.0',
      category: '2D',
      actor: 'Tom Cruise',
      genre: 'Action,Thriller',
      release: '14-07-2023',
      language: 'English',
    },
    show_time: [
      {
        date: '20th , August 2023',
        date_name: 'Sunday ',
        slot: [
          {
            time: '01:20 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '07:15 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '21st , August 2023',
        date_name: 'Monday ',
        slot: [
          {
            time: '01:20 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '07:15 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '22nd , August 2023',
        date_name: 'Tuesday ',
        slot: [
          {
            time: '01:20 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '07:15 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
      {
        date: '23rd , August 2023',
        date_name: 'Wednesday ',
        slot: [
          {
            time: '01:20 PM',
            hall: 1,
            hall_id: 9,
            hall_type: 'Regular',
          },
          {
            time: '07:15 PM',
            hall: 1,
            hall_id: 7,
            hall_type: 'Regular',
          },
        ],
      },
    ],
  },
];
